var map = {
	"./aoty-da-DK.svg": 56988,
	"./aoty-de-DE.svg": 27806,
	"./aoty-en-GB.svg": 26536,
	"./aoty-en-US.svg": 30593,
	"./aoty-es-ES.svg": 77430,
	"./aoty-es-MX.svg": 93393,
	"./aoty-fr-FR.svg": 2276,
	"./aoty-it-IT.svg": 14849,
	"./aoty-nb-NO.svg": 47382,
	"./aoty-nl-NL.svg": 70281,
	"./aoty-pl-PL.svg": 75975,
	"./aoty-pt-BR.svg": 37881,
	"./aoty-pt-PT.svg": 15687,
	"./aoty-sv-SE.svg": 86761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80663;